export function imageUrl(image) {
  if (!image) return '';
  const raw = image.url || image.s3_url || '';
  if (!raw) return '';
  if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('blob:')) {
    return raw;
  }
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}${raw.startsWith('/') ? raw : `/${raw}`}`;
}

export function parseTagsInput(value) {
  if (!value || typeof value !== 'string') return [];
  return value
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean);
}

export function tagsToInput(tags) {
  if (!Array.isArray(tags)) return '';
  return tags.join(', ');
}

export function imageCountLabel(count) {
  const n = Number(count) || 0;
  if (n === 1) return '1 image';
  return `${n} images`;
}

export function brandLabel(brand) {
  const value = String(brand || '').trim();
  if (!value || value.toLowerCase() === 'global') {
    return 'Global';
  }
  return value;
}

export function isGlobalBrand(brand) {
  return !brand || String(brand).trim().toLowerCase() === 'global';
}

/** Matches Laravel `max:10240` (kilobytes) on image uploads. */
export const IMAGE_MAX_BYTES = 10240 * 1024;

export const IMAGE_SIZE_ERROR_MESSAGE = 'Each image must be 10 MB or smaller.';

export function isImageWithinSizeLimit(file) {
  return !!(file && file.size <= IMAGE_MAX_BYTES);
}

export function partitionImagesBySize(files) {
  const valid = [];
  const oversized = [];

  (files || []).forEach((file) => {
    if (!file?.type?.startsWith('image/')) return;
    if (isImageWithinSizeLimit(file)) {
      valid.push(file);
    } else {
      oversized.push(file);
    }
  });

  return { valid, oversized };
}

export function getImageGroupSaveErrorMessage(error) {
  const errors = error?.response?.data?.errors;
  if (!errors || typeof errors !== 'object') {
    return null;
  }

  const imageKeys = Object.keys(errors).filter(
    (key) => key === 'images' || key.startsWith('images.'),
  );
  if (!imageKeys.length) {
    return null;
  }

  const messages = imageKeys.flatMap((key) => {
    const value = errors[key];
    return Array.isArray(value) ? value : [value];
  });
  const friendly = messages.find((msg) => typeof msg === 'string' && msg.trim());
  if (friendly) {
    return friendly;
  }

  return IMAGE_SIZE_ERROR_MESSAGE;
}
